import React, { Component } from 'react'
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import MyButton from '../../util/myButton';
//icon
import EditIcon from '@material-ui/icons/Edit';


import { connect } from 'react-redux';
import { editUserDetails } from '../../redux/actions/userActions';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = (theme) => ({
    ...theme.spread,
    button: {
        float: 'right'
    }
})

class EditDetails extends Component {
    constructor() {
        super();
        this.state = {
            bio: '',
            website: '',
            location: '',
            open: false

        };
    }

    mapUserDetailsToState = (credentials) => {
        this.setState(() => {
            return {
                bio: credentials.bio ? credentials.bio : '',
                website: credentials.website ? credentials.website : '',
                location: credentials.location ? credentials.location : '',

            }
        })
    }

    componentDidMount() {
        const { credentials } = this.props;
        this.mapUserDetailsToState(credentials);
    }

    handleOpen = () => {
        const { credentials } = this.props;
        this.setState(() => {
            return {
                open: true
            }
        }, this.mapUserDetailsToState(credentials));

    }

    handleClose = () => {
        this.setState(() => {
            return {
                open: false
            }
        })
    }

    handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;

        this.setState(() => {
            return {
                [name]: value
            }
        }, () => console.log(this.state))
    }

    handleSubmit = () => {
        const userDetails = {
            bio: this.state.bio,
            website: this.state.website,
            location: this.state.location,
        }
        this.props.editUserDetails(userDetails);
        this.handleClose();
    }

    render() {
        const { classes } = this.props;
        return (
            <React.Fragment>

                <MyButton tip='Edit Profile' btnClassName={classes.button} onClick={this.handleOpen}>
                    <EditIcon color='primary' />
                </MyButton>
                <Dialog open={this.state.open} onClose={this.handleClose} fullWidth maxWidth="sm">
                    <DialogTitle>Edit profile details</DialogTitle>
                    <DialogContent>
                        <form>
                            <TextField
                                name='bio' type='text' label='bio' multiline
                                rows='3' placeholder='a bio about yourself'
                                className={classes.TextField} value={this.state.bio}
                                onChange={this.handleChange}
                                fullWidth />
                            <TextField
                                name='website' type='text' label='website'
                                placeholder='a link to your personal website'
                                className={classes.TextField} value={this.state.website}
                                onChange={this.handleChange}
                                fullWidth />
                            <TextField
                                name='location' type='text' label='Location'
                                placeholder='Where do you live?'
                                className={classes.TextField} value={this.state.location}
                                onChange={this.handleChange}
                                fullWidth />
                        </form>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color='primary'>Cancel</Button>
                        <Button onClick={this.handleSubmit} color='primary'>Save</Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        )
    }
}


EditDetails.propTypes = {
    editUserDetails: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    credentials: state.user.credentials
})

export default connect(mapStateToProps, { editUserDetails })(withStyles(styles)(EditDetails));
